import React, { Component } from "react";
// import axios from "axios";
import classnames from "classnames";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { ReusableOnboardingButton } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import {
  InputBoxComponent,
  TextAreaReusableComponent,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import InputNumberFunc from "../../../../function/InputNumberFunc";
import Form from "react-bootstrap/Form";
import { IconButtonReusableComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  get_vendor_diners_tickets,
  add_vendor_users_tickets,
} from "../../../../store/actions/VendorUsersTicketsActions/vendorUsersTicketsActions";
import isEmpty from "../../../../store/validation/is-Empty";
import store from "../../../../store/store";
import { SET_VENDOR_TICKETS_USER_DETAILS } from "../../../../store/types";
import Media from "react-media";
import Alert from "react-s-alert";

export class AddUserTicketIssuesPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      title: "",
      requestId: "",
      diner_id: "",
      country_code: "",
      number: "",
      userName: "",
      userId: "",
      comment: "",
      allUsersTicketsDetails: [],
      flag: false,
      errors: {},
    };
  }

  // componentDidMount() {
  //   this.setState({ isLoading: true });
  //   axios
  //     .get("https://ipapi.co/json")
  //     .then((result) =>
  //       this.setState({
  //         country_code: result.data.country_calling_code,
  //         isLoading: false,
  //       })
  //     )
  //     .catch((error) =>
  //       this.setState({
  //         error,
  //         isLoading: false,
  //       })
  //     );
  // }

  componentDidMount() {
    if (
      !isEmpty(this.props.auth.user.VendorUser.country_code) !==
      this.state.country_code
    ) {
      this.setState({
        country_code: !isEmpty(this.props.auth.user.VendorUser.country_code)
          ? this.props.auth.user.VendorUser.country_code
          : "",
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.allVendorUsersTickets) !==
      nextState.allUsersTicketsDetails
    ) {
      return {
        allUsersTicketsDetails: !isEmpty(nextProps.allVendorUsersTickets)
          ? nextProps.allVendorUsersTickets
          : [],
        userName: !isEmpty(nextProps.getDetailsInfo.userName)
          ? nextProps.getDetailsInfo.userName
          : "",
        userId: !isEmpty(nextProps.getDetailsInfo.user_id)
          ? nextProps.getDetailsInfo.user_id
          : "",
      };
    }
  }

  componentDidUpdate() {
    const dataNew = this.state.allUsersTicketsDetails;
    if (this.state.flag === false) {
      if (this.state.diner_id.length > 1) {
        dataNew.filter((data) => {
          if (data.diner_id === this.state.diner_id) {
            let userName = data.user_details.name;
            let userId = data.user_id;
            console.log(userName, userId);
            store.dispatch({
              type: SET_VENDOR_TICKETS_USER_DETAILS,
              payload: {
                userName: userName,
                user_id: userId,
              },
            });
            this.setState({
              flag: true,
            });
          }
        });
      }
    }
  }

  onOpenModal = () => {
    this.setState({ open: true, errors: [] });
  };

  onCloseModal = () => {
    this.setState({ open: false, errors: [] });
  };

  onChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
      flag: false,
    });
    // this.props.clear_all_errors();
  };

  onChangeTextBox = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      errors: {},
    });
  };

  onFocusOut = (e) => {
    e.preventDefault();
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
    });
  };

  onGetData = (number) => (e) => {
    if (number.length > 9) {
      const vendorId = this.props.auth.user.VendorUser._id;
      const token = this.props.auth.user.accessToken;
      this.props.get_vendor_diners_tickets(
        vendorId,
        this.state.country_code.split("+")[1],
        number,
        token,
        "phone"
      );
    }
  };

  onGetRequestIdData = (diner_id) => (e) => {
    if (diner_id.length > 5) {
      const vendorId = this.props.auth.user.VendorUser._id;
      const token = this.props.auth.user.accessToken;
      this.props.get_vendor_diners_tickets(
        vendorId,
        this.state.country_code.split("+")[1],
        diner_id,
        token,
        "requestId"
      );
    }
  };

  onCallBackFunc = (e) => {
    this.setState({
      title: "",
      diner_id: "",
      number: "",
      userId: "",
      userName: "",
      comment: "",
    });
    this.onCloseModal();
  };

  onErrBackFunc = (err) => {
    Alert.error(`<h4>${err.response.data.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  onSubmitHandler = (e) => {
    e.preventDefault();
    const token = this.props.auth.user.accessToken;
    const formData = {
      seating_request_no: this.state.diner_id,
      description: this.state.title,
      comment: this.state.comment,
      refrence_images: [],
      user_id: this.state.userId,
    };

    this.props.add_vendor_users_tickets(
      formData,
      token,
      this.onCallBackFunc,
      (err) => this.onErrBackFunc(err)
    );
  };

  render() {
    const { open, errors, title, userName, comment } = this.state;
    return (
      <React.Fragment>
        <Media query="(max-width: 992px)">
          {/* <IconButtonReusableComponent
            buttonText="Add Ticket"
            onClick={this.onOpenModal}
            buttonType="button"
          /> */}
          <button
            type="button"
            className="btn btn-danger text-normal btn-xs rounded"
            onClick={this.onOpenModal}
          >
            + Add Ticket
          </button>
        </Media>
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "onBoarding-CustomOverlay-request-accept-cancelled",
            modal: "suggest-vendor-model-popup",
            // closeButton: "onBoarding-Custom-CloseButtonCalling",
            animationIn: "onBoardingCustomEnterAnimation",
            animationOut: "onBoardingCustomLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div>
            <div className="suggest-vendor-model-popup-header">
              <h4>User Ticket</h4>
            </div>
            <div className="suggest-vendor-model-popup-bodybox">
              <Form noValidate>
                <div className="row pt-3">
                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 pr-0">
                    {" "}
                    <Form.Group
                      className="reusableInputComponent-main mb-0"
                      controlId={"country_code"}
                    >
                      <div className="input-phone-country-code-reusable">
                        <select
                          name="country_code"
                          value={this.state.country_code}
                          onChange={this.onChange}
                        >
                          <option value={this.state.country_code}>
                            {this.state.country_code}
                          </option>
                          {getCountries().map((country) => (
                            <option
                              key={country}
                              value={"+" + getCountryCallingCode(country)}
                            >
                              {en[country]} (+{getCountryCallingCode(country)})
                            </option>
                          ))}
                        </select>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 pl-0">
                    <InputBoxComponent
                      displayLabel={false}
                      controlId="number"
                      labelText="Mobile Number"
                      inputType="number"
                      placeHolder="Enter mobile number"
                      maxLength="10"
                      name="number"
                      onChange={this.onChange}
                      onFocusOut={this.onFocusOut}
                      onKeyUp={this.onGetData(this.state.number)}
                      onKeyDown={InputNumberFunc}
                      value={this.state.number}
                      required="required"
                      showBottom={true}
                      error={
                        this.state.number.length > 0 &&
                        this.state.number.length <= 9
                          ? "Enter valid Mobile Number"
                          : null || this.state.number === ""
                          ? errors.number
                          : null
                      }
                      inputClassName={classnames("input-component-inputfield", {
                        invalid: errors.mobile_number,
                      })}
                    />
                    {/* {this.state.number.length > 9
                      ? this.onGetData()
                      : null} */}
                    <Form.Text className="text-muted input-component-bottom">
                      <div className="text-danger text-capitalize">
                        {errors.message}
                      </div>
                    </Form.Text>
                  </div>
                  <div className="col-12 text-center">
                    <p
                      style={{ fontFamily: "Roboto-Regular", color: "#BCBCBC" }}
                    >
                      OR
                    </p>
                  </div>
                </div>
                {this.state.number.length > 0 ? (
                  <div className="row">
                    <div className="col-12 mt-4">
                      <Form.Group className="reusableInputComponent-main mb-0">
                        <Form.Label className="input-component-labeltext inline-css">
                          Request ID
                        </Form.Label>
                      </Form.Group>
                      <div className="input-phone-country-code-reusable w-100">
                        <select
                          name="diner_id"
                          value={this.state.diner_id}
                          onChange={this.onChange}
                          className="w-100"
                        >
                          <option value={this.state.diner_id}>
                            {this.state.diner_id}
                          </option>
                          {this.state.allUsersTicketsDetails.map(
                            (country, index) => (
                              <option key={index} value={country.diner_id}>
                                {country.diner_id}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-12">
                      <InputBoxComponent
                        displayLabel={true}
                        controlId="diner_id"
                        labelText="Request ID"
                        placeHolder="eg. Jhatka"
                        inputType="number"
                        name="diner_id"
                        maxLength="6"
                        onChange={this.onChange}
                        onFocusOut={this.onFocusOut}
                        onKeyDown={InputNumberFunc}
                        value={this.state.diner_id}
                        onKeyUp={this.onGetRequestIdData(this.state.diner_id)}
                        required="required"
                        showBottom={true}
                        error={
                          this.state.diner_id === "" ? errors.diner_id : " "
                        }
                        inputClassName={classnames(
                          "input-component-inputfield",
                          {
                            invalid: errors.diner_id,
                          }
                        )}
                      />
                    </div>
                  </div>
                )}

                <InputBoxComponent
                  displayLabel={true}
                  controlId="userName"
                  labelText="User Name"
                  placeHolder="eg. Jhatka"
                  name="userName"
                  maxLength="35"
                  onChange={this.onChange}
                  onFocusOut={this.onFocusOut}
                  value={this.state.userName}
                  disabled={true}
                  required="required"
                  showBottom={true}
                  error={errors.userName}
                  inputClassName={classnames("input-component-inputfield", {
                    invalid: errors.userName,
                  })}
                />
                <InputBoxComponent
                  displayLabel={true}
                  controlId="Title"
                  labelText="Title"
                  placeHolder="eg. Jhatka"
                  name="title"
                  onChange={this.onChange}
                  onFocusOut={this.onFocusOut}
                  value={this.state.title}
                  maxLength="35"
                  required="required"
                  showBottom={true}
                  error={errors.title}
                  inputClassName={classnames("input-component-inputfield", {
                    invalid: errors.title,
                  })}
                />
                <TextAreaReusableComponent
                  controlId="comment"
                  displayText={true}
                  labelText="Comment"
                  labelTextClass="text-area-lable"
                  placeholder="Eg. A Bright Atmosphere"
                  rows="6"
                  onChange={this.onChangeTextBox}
                  onFocusOut={this.onFocusOut}
                  name="comment"
                  value={this.state.comment}
                  inputClassName={classnames("input-text-area text-area-new", {
                    invalid: errors.comment,
                  })}
                  error={this.state.comment === "" ? errors.comment : " "}
                />
              </Form>
              <div className="d-flex justify-content-between mt-3">
                <ReusableOnboardingButton
                  buttonText="Cancel"
                  buttonTitle="Cancel Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  onClick={this.onCloseModal}
                />
                <ReusableOnboardingButton
                  buttonText="Confirm"
                  buttonTitle="Confirm Button"
                  buttonClass={
                    title === "" || userName === "" || comment === ""
                      ? // ||
                        // (requestId <= 0 && number.length <= 0)
                        "onboarding_button_link_reusable onboarding_button_link_reusable_gray"
                      : "onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  }
                  disabled={
                    title === "" || userName === "" || comment === ""
                      ? // ||
                        // (requestId <= 0 && number.length <= 0)
                        true
                      : false
                  }
                  onClick={this.onSubmitHandler}
                />
              </div>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

AddUserTicketIssuesPopup.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  allVendorUsersTickets: state.vendorUsersTickets.vendor_get_diner_mobile,
  getDetailsInfo: state.allDinerDetails.set_vendor_tickets_user_details,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_vendor_diners_tickets,
  add_vendor_users_tickets,
})(withRouter(AddUserTicketIssuesPopup));
